import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { supabase } from '../lib/clients/supabase';

export const MembershipContext = createContext();

export const MembershipProvider = ({ children }) => {
    const { currentUser } = useAuth();
    const [selectedMembership, setSelectedMembership] = useState(null);
    const [registrationComplete, setRegistrationComplete] = useState(false);
    const [paymentStep, setPaymentStep] = useState('select'); // select, register, payment
    const [userMemberships, setUserMemberships] = useState([]);
    const [tempUserData, setTempUserData] = useState({
        firstName: '',
        lastName: '',
        email: ''
    });

    useEffect(() => {
        if (currentUser) {
            // fetchUserMemberships();
        }
    }, [currentUser]);

    const fetchUserMemberships = async () => {
        try {
            const { data, error } = await supabase
                .from('memberships')
                .select('*')
                .eq('user_id', currentUser?.id)
                .eq('status', 'active');

            if (error) throw error;
            setUserMemberships(data || []);
        } catch (error) {
            console.error('Error fetching memberships:', error);
        }
    };

    const selectMembership = (membership) => {
        setSelectedMembership(membership);
        if (currentUser) {
            setPaymentStep('payment');
        } else {
            setPaymentStep('register');
        }
    };

    const goBack = () => {
        if (paymentStep === 'payment' && !currentUser) {
            setPaymentStep('register');
        } else {
            setPaymentStep('select');
            setSelectedMembership(null);
            setRegistrationComplete(false);
        }
    };

    const registerUser = async (userData) => {
        setTempUserData(userData);
        setRegistrationComplete(true);
        setPaymentStep('payment');
    };

    const processPayment = async (paymentDetails) => {
        try {
            // Here we'll integrate with Square payment
            // For now, just save the membership to Supabase
            const { error } = await supabase
                .from('memberships')
                .insert({
                    user_id: currentUser?.id,
                    membership_type: selectedMembership.name,
                    price: selectedMembership.price,
                    status: 'active',
                    registration_fee_paid: true,
                    start_date: new Date().toISOString(),
                    temp_user_data: !currentUser ? tempUserData : null
                });

            if (error) throw error;
            // await fetchUserMemberships();
            return { success: true };
        } catch (error) {
            console.error('Error processing payment:', error);
            return { success: false, error };
        }
    };

    return (
        <MembershipContext.Provider value={{
            selectedMembership,
            paymentStep,
            tempUserData,
            registrationComplete,
            userMemberships,
            selectMembership,
            registerUser,
            processPayment,
            goBack
        }}>
            {children}
        </MembershipContext.Provider>
    );
};

export const useMembership = () => {
    const context = useContext(MembershipContext);
    if (!context) {
        throw new Error('useMembership must be used within a MembershipProvider');
    }
    return context;
}; 